/**
 * @module "ethpm/manifests"
 */

import * as v3 from './v3';

export * from './service';
export { v3 };
